export default "__VITE_ASSET__BMVHkPko__"